import { useContentfulLiveUpdates } from '@contentful/live-preview/react'
import resolveResponse from 'contentful-resolve-response'
import * as React from 'react'
import { useParams } from 'react-router-dom'

import { useContentAPI } from '../../../Hooks/useAPI'
import Header from './Header'

const MaterializedHeader = () => {
  const params = useParams()
  const paths = Object.values(params).join('/')
  const isPreviewMode = paths.includes('preview/')

  const { data } = useContentAPI('contentType', 'headerComponent', '', isPreviewMode)
  const previewData = useContentfulLiveUpdates(data)
  const resolver = {
    items: isPreviewMode ? previewData?.data?.items : data?.data?.items,
    includes: isPreviewMode ? previewData?.data?.includes : data?.data?.includes,
  }

  const contentData = data && data !== null ? resolveResponse(resolver)?.[0] : {}
  if (!data) return <></>
  return <Header content={contentData} />
}

export default MaterializedHeader
